// extracted by mini-css-extract-plugin
export default {"heading_container":"HeadingWithGrid_heading_container__vwoI+","heading":"HeadingWithGrid_heading__0fEOC"};